import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Library',
  recent: 'Recent files',
  allFiles: 'Uploaded files',
  vimeoFiles: 'Vimeo files',
  delete: 'Delete',
  fileIsUsed:
    'This file is being used in active learning content and therefore cannot be deleted',
  fileIsUsedEdit:
    'This file is used as part of a lesson in a course and cannot be edited',
  fileIsGenerating: 'This video is being generated',
  confirmDelete: 'Are you sure you want to delete this file from your library?',
  fileDeleted: 'File deleted',
  generateWithAI: 'Generate with AI assistant',
  aiFiles: 'AI generated files',
  videoUploaded: 'File uploaded successfully',
  downloadTranscript: 'Download transcript',
  downloadVideoTranscription: 'Download video transcription',
  videoIsGenerating: 'Video is processing ...',
  preview: 'Preview',
  editVideo: 'Edit video',
  downloadFile: 'Download file',
  generatingThumbnail: 'Generating thumbnail',
  updateJob: 'Refresh',
  cancelJob: 'Stop process',
  confirmCancelJob: 'Are you sure you want to stop the process?',
  confirmCancelJobAccept: 'Yes',
  cancelJobDisabledTooltip:
    'Cancellation is not available at this processing stage',
};

const welsh = {
  title: 'Llyfrgell',
  recent: 'Ffeiliau diweddar',
  allFiles: "Ffeiliau wedi'u uwchlwytho",
  vimeoFiles: 'Ffeiliau vimeo',
  delete: 'Dileu',
  fileIsUsed:
    "Mae'r ffeil hon yn cael ei defnyddio yn y cynnwys dysgu actif ac felly ni ellir ei dileu",
  fileIsUsedEdit:
    "Mae'r ffeil hon yn cael ei ddefnyddio fel rhan o wers yn y cwrs ac ni ellir ei olygu",
  fileIsGenerating: "Mae'r fideo hwn yn cael ei gynhyrchu",
  confirmDelete:
    "Ydych chi'n siŵr eich bod am ddileu'r ffeil hon o'ch llyfrgell?",
  fileDeleted: "Ffeil wedi'i ddileu",
  generateWithAI: 'Cynhyrchwch  gyda cynorthwy-ydd AI',
  aiFiles: 'Ffeiliau a gynhyrchwyd gan AI',
  videoUploaded: "Ffeil wedi'i wwchlwytho'n llwyddiannus",
  downloadTranscript: "Lawrlwytho'r trawsgrifiad",
  downloadVideoTranscription: "Lawrlwytho'r trawsgrifiad fideo",
  generatingThumbnail: 'Generating thumbnail',
  updateJob: 'Update job',
  cancelJob: 'Cancel job',
  confirmCancelJob: 'Are you sure you want to cancel this job?',
  confirmCancelJobAccept: 'Yes, cancel job',
  cancelJobDisabledTooltip:
    'Cancellation is not available at this processing stage',
};

export const videoSourcesText: any = getLocalizationBasedOnLang(english, welsh);
